<template>
  <div class="newList">
    <div class="banner">
      <img src="../../assets/image/maxHomeLogo.png" alt />
    </div>
    <div class="allData" v-if="!idStatus">
      <div
        class="dataMain"
        v-for="(item, index) in dataList.slice(
          (pageIndex - 1) * pageSize,
          pageIndex * pageSize
        )"
        :key="index"
      >
        <div class="dataMain_left">
          <el-image :src="$getSrc(item.image)"></el-image>
        </div>
        <div class="dataMain_right">
          <p>
            <span>{{ item.title }}</span>
            <span>{{ item.uploadDate }}</span>
          </p>
          <!-- <p>{{ item.remarks }}</p> -->
          <pre>{{ item.remarks }}</pre>
          <p @click="eventDataInfo(item.id)">查看 > ></p>
        </div>
      </div>
      <div class="fenye">
        <el-pagination
          background
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          :page-size="pageSize"
          :total="totalPage"
          layout="prev, pager, next, slot "
        >
        </el-pagination>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>
<script>
import myFooter from "../Footer";
export default {
  components: {
    myFooter,
  },
  data() {
    return {
      dataList: [],
      pageSize: 6, // 每页条数
      pageIndex: 1, // 当前页
      totalPage: 0, // 总条数
    };
  },
  mounted() {
    this.getlistDate();
  },
  methods: {
    getlistDate() {
      this.$http({
        url: "promotion/getBigIndex",
        method: "get",
      })
        .then(({ data }) => {
          let { code, bigMsg } = data;
          if (code === 0) {
            bigMsg.forEach((ele) => {
              ele.uploadDate = ele.uploadDate.substring(0, 10);
            });
            this.dataList = bigMsg;
            this.totalPage = bigMsg.length;
          } else {
            console.log(msg);
          }
        })
        .catch((err) => console.log(err));
    },

    eventDataInfo(id) {
      if (id) {
        this.$router.push({
          path: "moreInfoDetail",
          query: {
            moreId: id
          }
        })
      }
    },

    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
    },
  },
};
</script>
<style lang="scss">
.newList {
  .fenye {
    width: 1200px;
    height: 32px;
    text-align: center;
    margin: 30px auto 128px;
    position: absolute;
    .el-icon-arrow-left:before {
      content: "上一页";
    }
    .el-icon-arrow-right:before {
      content: "下一页";
    }
    .el-pagination {
      padding: 0;
    }
    .btn-prev,
    .btn-next,
    .tiaoBtn {
      width: 54px;
      height: 32px;
      background-color: #eeeeee;
      line-height: 54px;
      color: #424242 !important;
    }
    .el-pager {
      li {
        width: 32px;
        height: 32px;
        background-color: #eeeeee;
        color: #525252;
        line-height: 32px;
      }
    }
    .el-pagination.is-background .el-pager li {
      &:hover {
        color: #2776ec;
      }
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #2776ec;
      &:hover {
        color: #ffffff;
      }
    }
    .tiaoInp {
      width: 32px;
      height: 32px;
      .el-input__inner {
        padding: 0;
        border-radius: 0;
        height: 32px;
      }
    }
    .tiaoBtn {
      border-radius: 2px;
      margin-left: 8px;
    }
    .el-pagination span:not([class*="suffix"]),
    .el-pagination button {
      line-height: 32px;
    }
  }
}
</style>
<style lang="scss" scoped>
.newList {
  min-width: 1200px;
  .banner {
    height: 186px;
    text-align: center;
    border-bottom: 2px solid #d5d5d5;
    margin-bottom: 20px;
    img {
      margin-top: 36px;
    }
  }
  .allData {
    width: 1200px;
    min-height: 1265px;
    margin: auto;
    padding-top: 1px;
    .dataMain {
      height: 178px;
      border-bottom: 1px solid #bbbbbb;
      //   margin-top: 20px;
      position: relative;
    }
    .dataMain_left {
      width: 270px;
      height: 138px;
      float: left;
      margin-top: 20px;
      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    .dataMain_right {
      width: 871px;
      float: right;
      margin-top: 17px;
      //   color: #ffffff;
      p:first-child {
        height: 18px;
        line-height: 18px;
        span:first-child {
          width: 538px;
          float: left;
          font-size: 18px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: bold;
        }
        span:last-child {
          float: right;
          font-size: 12px;
        }
      }
      pre {
        width: 677px;
        height: 68px;
        margin-top: 28px;
        font-family: "微软雅黑";
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -pre-wrap;
        white-space: -o-pre-wrap;
        word-wrap: break-word;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        font-size: 14px;
        line-height: 23px;
      }
      p:last-child {
        width: 86px;
        height: 30px;
        font-size: 13px;
        text-align: center;
        line-height: 30px;
        border: 1px solid #bbbbbb;
        background-color: #ffffff;
        color: #8a8a8a;
        position: absolute;
        right: 0;
        bottom: 25px;
        cursor: pointer;
      }
    }
  }
}
</style>